import { createAction, props } from '@ngrx/store';
import { CentralRegulatorDTO } from '@iota/inh-core-v1-management-client';

export enum CentralRegulatorDeactivationActionTypes {
    CreateDeactivation = '[Central Regulator Deactivation] Create Deactivation',
    CreateDeactivationSuccess = '[Central Regulator Deactivation] Create Deactivation Success',
    CreateDeactivationFailure = '[Central Regulator Deactivation] Create Deactivation Failure',

    UpdateDeactivation = '[Central Regulator Deactivation] Update Deactivation',
    UpdateDeactivationSuccess = '[Central Regulator Deactivation] Update Deactivation Success',
    UpdateDeactivationFailure = '[Central Regulator Deactivation] Update Deactivation Failure',

    CancelDeactivation = '[Central Regulator Deactivation] Cancel Deactivation',
    CancelDeactivationSuccess = '[Central Regulator Deactivation] Cancel Deactivation Success',
    CancelDeactivationFailure = '[Central Regulator Deactivation] Cancel Deactivation Failure',

    RevertDeactivation = '[Central Regulator Deactivation] Revert Deactivation',
    RevertDeactivationSuccess = '[Central Regulator Deactivation] Revert Deactivation Success',
    RevertDeactivationFailure = '[Central Regulator Deactivation] Revert Deactivation Failure'
}

export const CreateCentralRegulatorDeactivation = createAction(
    CentralRegulatorDeactivationActionTypes.CreateDeactivation,
    props<{ centralRegulatorId: string; deactivationDate: string }>()
);

export const CreateCentralRegulatorDeactivationSuccess = createAction(
    CentralRegulatorDeactivationActionTypes.CreateDeactivationSuccess,
    props<{ centralRegulator: CentralRegulatorDTO }>()
);

export const CreateCentralRegulatorDeactivationFailure = createAction(
    CentralRegulatorDeactivationActionTypes.CreateDeactivationFailure,
    props<{ error: string }>()
);

export const UpdateCentralRegulatorDeactivation = createAction(
    CentralRegulatorDeactivationActionTypes.UpdateDeactivation,
    props<{ centralRegulatorId: string; deactivationDate: string }>()
);

export const UpdateCentralRegulatorDeactivationSuccess = createAction(
    CentralRegulatorDeactivationActionTypes.UpdateDeactivationSuccess,
    props<{ centralRegulator: CentralRegulatorDTO }>()
);

export const UpdateCentralRegulatorDeactivationFailure = createAction(
    CentralRegulatorDeactivationActionTypes.UpdateDeactivationFailure,
    props<{ error: string }>()
);

export const CancelCentralRegulatorDeactivation = createAction(
    CentralRegulatorDeactivationActionTypes.CancelDeactivation,
    props<{ centralRegulatorId: string }>()
);

export const CancelCentralRegulatorDeactivationSuccess = createAction(
    CentralRegulatorDeactivationActionTypes.CancelDeactivationSuccess,
    props<{ centralRegulator: CentralRegulatorDTO }>()
);

export const CancelCentralRegulatorDeactivationFailure = createAction(
    CentralRegulatorDeactivationActionTypes.CancelDeactivationFailure,
    props<{ error: string }>()
);

export const RevertCentralRegulatorDeactivation = createAction(
    CentralRegulatorDeactivationActionTypes.RevertDeactivation,
    props<{ centralRegulatorId: string }>()
);

export const RevertCentralRegulatorDeactivationSuccess = createAction(
    CentralRegulatorDeactivationActionTypes.RevertDeactivationSuccess,
    props<{ centralRegulator: CentralRegulatorDTO }>()
);

export const RevertCentralRegulatorDeactivationFailure = createAction(
    CentralRegulatorDeactivationActionTypes.RevertDeactivationFailure,
    props<{ error: string }>()
);
